module.exports = __webpack_public_path__ + "static/media/Dynamic_Asset_Allocation.72aec152.svg";